<app-loader></app-loader>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="revenuedashboard-main">
        <div class="driver-list-outer overview-revenue">
            <div class="overview-heading">
                <div class="revenue-date">
                    <h4>Overview - Revenue Collection</h4>
                    <p class="calendar-icon"><img src="assets/images/calendar-new.svg"
                            alt="calender" /><span>{{startDate}} to {{endDate}}</span></p>
                </div>

<div class="main-invoice">
                    <div class="booking-invoice" *ngFor="let card of paymentCardsData"
                        [ngClass]="{'custom-invoice': card.label=== 'Custom Invoice'}">
                        <div class="booking-inner">
                            <div class="booking-text">
                                <img src="{{card.image}}" alt="" />
                                <p [innerHTML]="card.label"></p>
                            </div>
                            <div class="booking-number">
                                <span class="custom-number">{{card.pCount}}</span>
                                <div class="pending-number">
                                    <h3>${{ card.pAmount | number: '1.2-2' }}</h3>
                                    <h5>{{ card.pTitle }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="booking-number">
                            <span class="custom-number">{{card.fCount}}</span>
                            <div class="pending-number">
                                <h3>${{ card.fAmount | number: '1.2-2' }}</h3>
                                <h5>{{ card.fTitle }}</h5>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="card parking-list">
                <p-table id="tbl-top" [value]="revenueCollectionData?.data" [resizableColumns]="true"
                    columnResizeMode="expand">
                    <ng-template pTemplate="header">
                        <tr class="top-strips">
                            <th colspan="3" scope="col"></th>
                            <th colspan="2" class="border-left" scope="col">
                                <div class="booking-bg"><span>Bookings</span></div>
                            </th>
                            <th colspan="2" class="border-left border-right" scope="col">
                                <div class="booking-bg"><span>Custom Invoices</span></div>
                            </th>
                            <th scope="col"></th>
                        </tr>
                        <tr class="top-heading">
                            <th scope="col">Company Name</th>
                            <th scope="col">Parking Lot</th>
                            <th scope="col">Address</th>
                            <th scope="col" class="border-left" scope="col">Pending Payments
                            </th>
                            <th scope="col">Failed Payments
                            </th>
                            <th class="border-left" scope="col">Pending Payments </th>
                            <th class="border-right" scope="col">
                                Failed Payments
                            </th>
                            <th scope="col">Actions
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr class="border12">
                            <td class="custom-cursor" (click)="viewTicket(rowData)">
                                <div class="driver-names"><img [src]="(rowData?.companyLogo || dummy)"
                                        alt="Company logo" />
                                    <span>{{ rowData.driverName }}</span>
                                    <p>{{ rowData?.companyName }}
                                    </p>
                                </div>
                            </td>
                            <td class="custom-cursor" (click)="viewTicket(rowData)">
                                <div class="driver-email">{{rowData?.parkingLotName}}</div>
                            </td>
                            <td class="custom-cursor" (click)="viewTicket(rowData)">
                                <div class="mobile-number">{{rowData?.address}}</div>
                            </td>
                            <td class="border-left">
                                <div class="booking-common booking-pending">{{rowData?.paymentPendingCount}}
                                </div>
                            </td>
                            <td>
                                <div class="booking-common booking-failed">
                                    {{rowData?.paymentFailedCount}}</div>
                            </td>
                            <td class="border-left">
                                <div class="booking-common booking-pending">
                                    {{rowData?.customInvoicePaymentPendingCount}}</div>
                            </td>
                            <td class="border-right">
                                <div class="booking-common booking-failed">
                                    {{rowData?.customInvoicePaymentFailedCount}}</div>
                            </td>
                            <td>
                                <div class="export-btn">
                                    <img (click)="activeItem = rowData;showData(rowData);menu.toggle($event)"
                                        src="assets/images/dashboard-dot.svg" alt="" />
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr class="no-border">
                            <td class="no-record" colspan="8">
                                No Record Found
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <div class="card flex justify-content-end custom-pagination2"
                    *ngIf="revenueCollectionData?.data?.length > 0">
                    <p-paginator [first]="first" [rows]="10" [totalRecords]="revenueCollectionData?.totalRecords"
                        (onPageChange)="onPageChange($event)"></p-paginator>
                </div>
            </div>
        </div>
        <div class="custom-export"> <p-menu #menu [model]="items" [popup]="true"></p-menu>
        </div>
</div>